var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _vm.modal
        ? _c("modal-visualizar-gleba", {
            attrs: { idGleba: _vm.idGleba, titulo: _vm.titulo },
            on: {
              closeModal: function($event) {
                return _vm.closeModal()
              }
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              configuracaoFiltro: _vm.configuracaoFiltro,
              filtro: _vm.filtro,
              isConsultaProcessosAntigos: false
            },
            on: {
              pesquisar: _vm.pesquisar,
              limpar: _vm.clearFiltro,
              changePesquisa: _vm.changePesquisa
            }
          })
        ],
        1
      ),
      _c(
        "app-listagem",
        {
          attrs: {
            hasActionButton: true,
            sizeActionButton: _vm.sizeActionButton,
            nameActionButton: _vm.nameActionButton,
            hasHeader: true,
            hasRefreshButton: false,
            headerLabel: _vm.headerLabel,
            dataForTable: _vm.glebas,
            totalElements: _vm.totalElements,
            pagina: _vm.filtro.pagina + 1
          },
          on: {
            click: _vm.cadastrar,
            changePage: _vm.changePage,
            sort: _vm.sort
          }
        },
        [
          _c(
            "template",
            { slot: "columns" },
            [
              _c("el-table-column", {
                attrs: {
                  formatter: function(row) {
                    return _vm.setData(row.dataCadastro)
                  },
                  label: "Data de Cadastro",
                  "min-width": "120",
                  prop: "dataCadastro",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Município da gleba",
                  "min-width": "120",
                  formatter: function(row) {
                    return _vm.getMunicipiosNome(row.municipios)
                  },
                  prop: "municipios",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Nome da gleba",
                  prop: "nome",
                  "min-width": "120",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Área total(ha)",
                  prop: "areaTotal",
                  formatter: function(row) {
                    return _vm.formatarArea(row.areaTotal)
                  },
                  "min-width": "120",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Área remanescentes(ha)",
                  prop: "areaRemanescente",
                  formatter: function(row) {
                    return _vm.formatarArea(row.areaRemanescente)
                  },
                  sortable: "sortable",
                  "min-width": "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Matrícula",
                  prop: "matricula",
                  sortable: "sortable",
                  "min-width": "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Data matrícula",
                  formatter: function(row) {
                    return _vm.setData(row.dataMatricula)
                  },
                  "min-width": "120",
                  prop: "dataMatricula",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "small" } },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "mini" } },
                              [
                                _vm._v("Ações"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.visualizar(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-eye icon-teste"
                                          }),
                                          _vm._v("  Visualizar")
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.editar(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fal fa-pencil-alt icon-teste"
                                          }),
                                          _vm._v("  Editar")
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.remove(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-times icon-teste"
                                          }),
                                          _vm._v("  Excluir")
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "container-exportar" },
        [
          _c("el-button", { on: { click: _vm.exportar } }, [
            _c("span", [
              _c("i", { staticClass: "fal fa-file-csv" }),
              _vm._v("  Exportar CSV")
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7912b6a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7912b6a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/bancoDados/gleba/GlebaImovel.vue
// module id = null
// module chunks = 